<template>
  <v-container>
    <v-row>
      <v-col sm="3">
        <v-card>
          <v-card-title>Kunden Gesamt</v-card-title>
          <v-card-text>
            <h1 v-if="totalCustomers >= 0">{{ totalCustomers }}</h1>
            <h2 v-else>Keine Daten verfügbar</h2>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col sm="3">
        <v-card>
          <v-card-title>Benutzer</v-card-title>
          <v-card-text>
            <div v-if="Users.length >= 0">
              <div>Gesamt: {{ Users.length }}</div>
              <div>Aktiv: {{ activeUsers }}</div>
              <div>Inaktiv: {{ inactiveUsers }}</div>
              <div>Nicht aktiviert: {{ notActivatedUsers }}</div>
            </div>

            <h2 v-else>Keine Daten verfügbar</h2>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3">
        <v-card :loading="!statsLoaded">
          <v-card-title>Lizenzgebühren</v-card-title>
          <v-card-text>
            <div v-if="orderStats.fees.currentMonth">
              <h3>Monat: {{ currentMonth.format("MMMM") }}</h3>
              <div>
                Gesamt Tellergerichte:
                {{ orderStats.fees.currentMonth.totalAmount }}
              </div>
              <div>
                Betrag:
                {{
                  new Intl.NumberFormat("de-de", {
                    style: "currency",
                    currency: "EUR"
                  }).format(orderStats.fees.currentMonth.feeCent / 100)
                }}
              </div>
            </div>
            <div v-if="orderStats.fees.lastMonth">
              <h3>Monat: {{ lastMonth.format("MMMM") }}</h3>
              <div>
                Gesamt Tellergerichte:
                {{ orderStats.fees.lastMonth.totalAmount }}
              </div>
              <div>
                Betrag:
                {{
                  new Intl.NumberFormat("de-de", {
                    style: "currency",
                    currency: "EUR"
                  }).format(orderStats.fees.lastMonth.feeCent / 100)
                }}
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <v-card :loading="!statsLoaded">
          <v-card-title>Tellergerichte Übersicht</v-card-title>
          <v-card-text style="max-height: 400px;">
            <LizenzChart
              v-if="statsLoaded"
              :chartValues="['amount']"
              :chartdata="orderStats.fees.currentYear"
              :options="{
                maintainAspectRatio: false
              }"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card :loading="!statsLoaded">
          <v-card-title>Lizenzgebühren Übersicht</v-card-title>
          <v-card-text style="max-height: 400px;">
            <LizenzChart
              v-if="statsLoaded"
              :chartValues="['fee']"
              :chartdata="orderStats.fees.currentYear"
              :options="{
                maintainAspectRatio: false
              }"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import OrderService from "@/services/OrderService.js";
import LizenzChart from "@/components/dashboard/LizenzChart";
import moment from "moment";
moment.locale("de-de");

export default {
  name: "DashboardAdmin",
  data: () => ({
    currentMonth: moment(),
    lastMonth: moment().subtract(1, "month"),
    totalCustomers: 0,
    totalUsers: 0,
    userStats: null,
    statsLoaded: false,
    orderStats: {
      fees: {
        currentMonth: {},
        lastMonth: {},
        currentYear: {}
      }
    }
  }),
  components: { LizenzChart },
  methods: {
    getLastMonthFees() {
      OrderService.fetchFees(this.lastMonth.month(), this.lastMonth.year())
        .then(result => {
          if (!result.data || result.data.length == 0) {
            this.orderStats.fees.lastMonth = {
              totalAmount: 0,
              feeCent: 0
            };
          } else {
            this.orderStats.fees.lastMonth = result.data[0];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getCurrentYearFees() {
      OrderService.fetchFees(null, this.currentMonth.year())
        .then(result => {
          this.orderStats.fees.currentYear = result.data;

          this.orderStats.fees.currentMonth =
            result.data[this.currentMonth.month()];
          this.statsLoaded = true;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {
    Users() {
      return this.$store.getters["user/getUserList"];
    },
    activeUsers() {
      return this.Users.filter(el => el.active === true).length;
    },
    inactiveUsers() {
      return this.Users.filter(el => el.active !== true).length;
    },
    notActivatedUsers() {
      return this.Users.filter(el => el.activation.activated !== true).length;
    }
  },

  created() {
    //DataService.apiClient.get("/stats/customers")
    this.$store
      .dispatch("customer/fetchCustomerList")
      .then(result => {
        this.totalCustomers = result.length;
      })
      .catch(() => {
        this.totalCustomers = -1;
      });

    this.$store
      .dispatch("user/fetchUserList")
      .then(result => {
        this.totalUsers = result.data.data;
      })
      .catch(() => {
        this.totalUsers = -1;
      });
  },

  mounted() {
    this.getLastMonthFees();
    this.getCurrentYearFees();
  }
};
</script>
<style scoped></style>
